var _get = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/get");

var _createClass = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _classCallCheck = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/assertThisInitialized");

var _inherits = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _wrapNativeSuper = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/wrapNativeSuper");

var axios = require('axios'),
    HttpsAgent = require('https').Agent,
    Promise = require('bluebird'),
    retry = require('retry');

var DEBUG_API_CALLS = new Set(['holding-queue', 'network-info', 'predictive-fer', 'audit-servers', 'federated-servers', 'configuration', 'process-list', 'authorities', 'reload-configuration', 'drop-rate', 'set-drop-rate', 'delay', 'set-delay', 'summary', 'messages']);
var DEFAULT_RETRY_STRATEGY = {
  retries: 3,
  factor: 2,
  minTimeout: 500,
  maxTimeout: 2000
};

var ApiError =
/*#__PURE__*/
function (_Error) {
  "use strict";

  _inherits(ApiError, _Error);

  function ApiError(method, params, error) {
    var _this;

    _classCallCheck(this, ApiError);

    var message = ["API call to [".concat(method, "] ")];

    if (typeof params === 'object') {
      message.push("with params ".concat(JSON.stringify(params), " "));
    }

    message.push("got rejected: ".concat(error.message, " (code: ").concat(error.code, ")"));
    _this = _possibleConstructorReturn(this, _getPrototypeOf(ApiError).call(this, message.join('')));
    _this.code = error.code;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), ApiError);
    }

    return _this;
  }

  return ApiError;
}(_wrapNativeSuper(Error));
/**
 * Describe the options of connection to factomd or factom-walletd.
 * @typedef {Object} ConnectionOptions
 * @property {string} [host=localhost] - IP or hostname. Default to localhost.
 * @property {number} [port=8088|8089] - Port. Default to 8088 for factomd and 8089 for walletd.
 * @property {string} [path=/v2] - Path to V2 API. Default to /v2.
 * @property {string} [debugPath=/debug] - Path to debug API. Default to /debug.
 * @property {string} [user] - User for basic authentication.
 * @property {string} [password] - Password for basic authentication.
 * @property {string} [protocol=http] - http or https. Default to http.
 * @property {number} [timeout=0] - Specifies the number of milliseconds before any API request times out.
 * If a request takes longer than `timeout`, the request will be aborted. Default is `0` (no timeout).
 * @property {boolean} [rejectUnauthorized=true] - Set to false to allow connection to a node with a self-signed certificate. Default to true.
 * @property {Object} [retry] - Retry strategy. For the detail of the options see {@link https://github.com/tim-kos/node-retry#retrytimeoutsoptions}. Default to {retries: 3, factor: 2, minTimeout: 500, maxTimeout: 2000}
 * @example
 * const cli = new FactomdCli({
 *      host: '52.202.51.228',
 *      port: 8088,
 *      path: '/',
 *      debugPath: '/debug',
 *      user: 'paul',
 *      password: 'pwd',
 *      protocol: 'https',
 *      rejectUnauthorized: false,
 *      timeout: 5000,
 *      retry: {
 *          retries: 3,
 *          factor: 2,
 *          minTimeout: 500,
 *          maxTimeout: 2000
 *      }
 * });
 */


var BaseCli =
/*#__PURE__*/
function () {
  "use strict";

  function BaseCli(conf, defaultPort) {
    _classCallCheck(this, BaseCli);

    var host = conf.host || 'localhost';
    var protocol = conf.protocol || 'http';
    var port = conf.port || defaultPort;
    var baseURL = "".concat(protocol, "://").concat(host, ":").concat(port);
    var httpCliOptions = {
      baseURL: baseURL,
      headers: {
        'Content-Type': 'application/json'
      }
    };

    if (typeof conf.user === 'string' && conf.user !== '') {
      httpCliOptions.auth = {
        username: conf.user,
        password: conf.password || ''
      };
      httpCliOptions.withCredentials = true;
    }

    if (protocol === 'https' && typeof conf.rejectUnauthorized !== 'undefined') {
      httpCliOptions.httpsAgent = new HttpsAgent({
        rejectUnauthorized: conf.rejectUnauthorized
      });
    }

    if (conf.timeout) {
      httpCliOptions.timeout = parseInt(conf.timeout);
    }

    this.httpCli = axios.create(httpCliOptions);
    this.path = conf.path || '/v2';
    this.apiCounter = newCounter();
    this.retry = conf.retry || DEFAULT_RETRY_STRATEGY;
    this.cookies = {};
  }

  _createClass(BaseCli, [{
    key: "_processCookieHeader",
    value: function _processCookieHeader(cookieHeader) {
      var _this2 = this;

      if (Array.isArray(cookieHeader)) {
        // Add or update cookie values
        cookieHeader.map(function (c) {
          return c.split(';')[0];
        }).forEach(function (c) {
          var keyVal = c.split('=');
          _this2.cookies[keyVal[0]] = keyVal[1];
        }); // Set Axios Cookie header with the updated cookies

        this.httpCli.defaults.headers.Cookie = Object.entries(this.cookies).map(function (c) {
          return "".concat(c[0], "=").concat(c[1]);
        }).join(';');
      }
    }
  }, {
    key: "call",
    value: function call(url, method, params, requestConfig) {
      var _this3 = this;

      var _ref = requestConfig || {},
          timeout = _ref.timeout,
          retryConfig = _ref.retry;

      return new Promise(function (resolve, reject) {
        var operation = retry.operation(retryConfig || _this3.retry);
        var data = {
          jsonrpc: '2.0',
          id: _this3.apiCounter(),
          method: method,
          params: params
        };
        operation.attempt(function () {
          _this3.httpCli.post(url, data, {
            timeout: timeout
          }).then(function (r) {
            _this3._processCookieHeader(r.headers['set-cookie']);

            resolve(r.data.result);
          }).catch(function (error) {
            return handleCallError({
              error: error,
              reject: reject,
              method: method,
              params: params,
              operation: operation
            });
          });
        });
      });
    }
  }]);

  return BaseCli;
}();

function handleCallError(_ref2) {
  var error = _ref2.error,
      reject = _ref2.reject,
      method = _ref2.method,
      params = _ref2.params,
      operation = _ref2.operation;
  var rejectionMessage;

  if (error.response) {
    var errorData = error.response.data;

    switch (error.response.status) {
      case 400:
        // Bad requests should not be retried
        if (typeof errorData.error === 'object') {
          // JSON RPC error
          return reject(new ApiError(method, params, errorData.error));
        } else {
          return reject(new Error(errorData));
        }

      case 401:
        // No need to retry unauthorized access errors
        return reject(new Error(error.response.data));

      default:
        rejectionMessage = typeof errorData === 'object' ? JSON.stringify(errorData) : errorData;
    }
  } else {
    rejectionMessage = error.message;
  }

  var rejection = new Error(rejectionMessage);

  if (!operation.retry(rejection)) {
    // If there is no more retry left, reject the promise with the most common error
    return reject(operation.mainError());
  }
}

function newCounter() {
  var i = 0;
  return function () {
    return ++i;
  };
}
/**
 * Factomd API client.
 * @param {ConnectionOptions} [conf] - Factomd connection options.
 */


var FactomdCli =
/*#__PURE__*/
function (_BaseCli) {
  "use strict";

  _inherits(FactomdCli, _BaseCli);

  function FactomdCli(conf) {
    var _this4;

    _classCallCheck(this, FactomdCli);

    var configuration = conf || {};
    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(FactomdCli).call(this, configuration, 8088));
    _this4.debugPath = configuration.debugPath || '/debug';
    return _this4;
  }
  /**
   * Make a call to factomd API. See {@link https://docs.factom.com/api#factomd-api}.
   * @async
   * @param {string} method - Factomd API method name.
   * @param {Object} [params] - The object that the factomd API is expecting.
   * @param {Object} [requestConfig] - Request configuration.
   * @param {number} [requestConfig.timeout] - Timeout in milliseconds for the request. Override the timeout set at the instance level.
   * @param {Object} [requestConfig.retry] - Retry strategy. For the detail of the options see {@link https://github.com/tim-kos/node-retry#retrytimeoutsoptions}.
   * Override the retry strategy set at the instance level.
   * @returns {Promise<Object>} - Factomd API response.
   */


  _createClass(FactomdCli, [{
    key: "call",
    value: function call(method, params, requestConfig) {
      var url = DEBUG_API_CALLS.has(method) ? this.debugPath : this.path;
      return _get(_getPrototypeOf(FactomdCli.prototype), "call", this).call(this, url, method, params, requestConfig);
    }
  }]);

  return FactomdCli;
}(BaseCli);
/**
 * Walletd API client.
 * @param {ConnectionOptions} [conf] - Walletd connection options.
 */


var WalletdCli =
/*#__PURE__*/
function (_BaseCli2) {
  "use strict";

  _inherits(WalletdCli, _BaseCli2);

  function WalletdCli(conf) {
    _classCallCheck(this, WalletdCli);

    var configuration = conf || {};
    return _possibleConstructorReturn(this, _getPrototypeOf(WalletdCli).call(this, configuration, 8089));
  }
  /**
   * Make a call to factom-walletd API. See {@link https://docs.factom.com/api#factom-walletd-api}.
   * @async
   * @param {string} method - Walletd API method name.
   * @param {Object} [params] - The object that the walletd API is expecting.
   * @param {Object} [requestConfig] - Request configuration.
   * @param {number} [requestConfig.timeout] - Timeout in milliseconds for the request. Override the timeout set at the instance level.
   * @param {Object} [requestConfig.retry] - Retry strategy. For the detail of the options see {@link https://github.com/tim-kos/node-retry#retrytimeoutsoptions}.
   * Override the retry strategy set at the instance level.
   * @returns {Promise<Object>} - Walletd API response.
   */


  _createClass(WalletdCli, [{
    key: "call",
    value: function call(method, params, requestConfig) {
      return _get(_getPrototypeOf(WalletdCli.prototype), "call", this).call(this, this.path, method, params, requestConfig);
    }
  }]);

  return WalletdCli;
}(BaseCli);

module.exports = {
  FactomdCli: FactomdCli,
  WalletdCli: WalletdCli
};